import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { registerAction2, MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';
import { ViewAction } from 'vscode/vscode/vs/workbench/browser/parts/views/viewPane';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { IOutlinePane, ctxAllCollapsed, ctxFollowsCursor, ctxFilterOnType, ctxSortMode } from 'vscode/vscode/vs/workbench/contrib/outline/browser/outline';

const _moduleId = "vs/workbench/contrib/outline/browser/outlineActions";
registerAction2(class CollapseAll extends ViewAction {
    constructor() {
        super({
            viewId: IOutlinePane.Id,
            id: 'outline.collapse',
            title: ( localizeWithPath(_moduleId, 0, "Collapse All")),
            f1: false,
            icon: Codicon.collapseAll,
            menu: {
                id: MenuId.ViewTitle,
                group: 'navigation',
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('view', IOutlinePane.Id)),
                     (ctxAllCollapsed.isEqualTo(false))
                )))
            }
        });
    }
    runInView(_accessor, view) {
        view.collapseAll();
    }
});
registerAction2(class ExpandAll extends ViewAction {
    constructor() {
        super({
            viewId: IOutlinePane.Id,
            id: 'outline.expand',
            title: ( localizeWithPath(_moduleId, 1, "Expand All")),
            f1: false,
            icon: Codicon.expandAll,
            menu: {
                id: MenuId.ViewTitle,
                group: 'navigation',
                when: ( (ContextKeyExpr.and(
                     (ContextKeyExpr.equals('view', IOutlinePane.Id)),
                     (ctxAllCollapsed.isEqualTo(true))
                )))
            }
        });
    }
    runInView(_accessor, view) {
        view.expandAll();
    }
});
registerAction2(class FollowCursor extends ViewAction {
    constructor() {
        super({
            viewId: IOutlinePane.Id,
            id: 'outline.followCursor',
            title: ( localizeWithPath(_moduleId, 2, "Follow Cursor")),
            f1: false,
            toggled: ctxFollowsCursor,
            menu: {
                id: MenuId.ViewTitle,
                group: 'config',
                order: 1,
                when: ( (ContextKeyExpr.equals('view', IOutlinePane.Id)))
            }
        });
    }
    runInView(_accessor, view) {
        view.outlineViewState.followCursor = !view.outlineViewState.followCursor;
    }
});
registerAction2(class FilterOnType extends ViewAction {
    constructor() {
        super({
            viewId: IOutlinePane.Id,
            id: 'outline.filterOnType',
            title: ( localizeWithPath(_moduleId, 3, "Filter on Type")),
            f1: false,
            toggled: ctxFilterOnType,
            menu: {
                id: MenuId.ViewTitle,
                group: 'config',
                order: 2,
                when: ( (ContextKeyExpr.equals('view', IOutlinePane.Id)))
            }
        });
    }
    runInView(_accessor, view) {
        view.outlineViewState.filterOnType = !view.outlineViewState.filterOnType;
    }
});
registerAction2(class SortByPosition extends ViewAction {
    constructor() {
        super({
            viewId: IOutlinePane.Id,
            id: 'outline.sortByPosition',
            title: ( localizeWithPath(_moduleId, 4, "Sort By: Position")),
            f1: false,
            toggled: ( (ctxSortMode.isEqualTo(0 ))),
            menu: {
                id: MenuId.ViewTitle,
                group: 'sort',
                order: 1,
                when: ( (ContextKeyExpr.equals('view', IOutlinePane.Id)))
            }
        });
    }
    runInView(_accessor, view) {
        view.outlineViewState.sortBy = 0 ;
    }
});
registerAction2(class SortByName extends ViewAction {
    constructor() {
        super({
            viewId: IOutlinePane.Id,
            id: 'outline.sortByName',
            title: ( localizeWithPath(_moduleId, 5, "Sort By: Name")),
            f1: false,
            toggled: ( (ctxSortMode.isEqualTo(1 ))),
            menu: {
                id: MenuId.ViewTitle,
                group: 'sort',
                order: 2,
                when: ( (ContextKeyExpr.equals('view', IOutlinePane.Id)))
            }
        });
    }
    runInView(_accessor, view) {
        view.outlineViewState.sortBy = 1 ;
    }
});
registerAction2(class SortByKind extends ViewAction {
    constructor() {
        super({
            viewId: IOutlinePane.Id,
            id: 'outline.sortByKind',
            title: ( localizeWithPath(_moduleId, 6, "Sort By: Category")),
            f1: false,
            toggled: ( (ctxSortMode.isEqualTo(2 ))),
            menu: {
                id: MenuId.ViewTitle,
                group: 'sort',
                order: 3,
                when: ( (ContextKeyExpr.equals('view', IOutlinePane.Id)))
            }
        });
    }
    runInView(_accessor, view) {
        view.outlineViewState.sortBy = 2 ;
    }
});
